import { connect } from 'react-redux';

import InPageSearchDisplay from './needs_refresh_manager.jsx';

import {
  setIsNeedsRefreshDisplayed
} from 'zoomforth_codesbane_viewer/action_creators/viewer.js';


const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    onNeedsRefreshDisplay: ()=> {
      dispatch(setIsNeedsRefreshDisplayed(true));
    }
  };
};


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InPageSearchDisplay);
